module.exports = __webpack_public_path__ + "static/digital206ad561384d4053c1cbf470924470cde.png";